import { motion } from 'framer-motion';
import { SectionHeader } from '@/components/dashboard/MetricCard';
import BrokerChat from '@/components/dashboard/BrokerChat';
import { useAccess } from '@/components/dashboard/access';

// Solo miembros de pago y equipo (ruta protegida con AccessGate en App.js)
export default function DashboardChat() {
  const { isBroker } = useAccess();
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="space-y-6"
      data-testid="dashboard-chat"
    >
      <SectionHeader
        title="Asistente IA"
        subtitle={isBroker ? 'Tu asistente personal con información del club, tus comisiones y tu red' : 'Tu asistente personal con información del club y de tu membresía'}
      />
      <BrokerChat />
    </motion.div>
  );
}
